import Vue from 'vue';
import Index from './Index.vue';
import router from './router';
import store from './store';
import {
  Icon,
  Button,
  Image,
  Divider,
  Tag,
  Table,
  TableColumn,
  Select,
  Option,
  Cascader,
  Pagination,
  Input,
  Col,
  Dialog,
  Form,
  FormItem,
  Message,
  Row,
  Radio,
  RadioGroup,
  RadioButton,
  Popconfirm,
  Upload,
  Breadcrumb,
  BreadcrumbItem,
  DatePicker,
  Checkbox,
  Menu,
  Submenu,
  MenuItem,
  MenuItemGroup,
  Empty,
} from 'element-ui';
import 'tailwindcss/tailwind.css';
import './assets/styles/common.css';
import 'element-ui/lib/theme-chalk/index.css';

Vue.config.productionTip = false;

Vue.use(Icon);
Vue.use(Button);
Vue.use(Image);
Vue.use(Divider);
Vue.use(Tag);
Vue.use(Table);
Vue.use(TableColumn);
Vue.use(Select);
Vue.use(Option);
Vue.use(Cascader);
Vue.use(Pagination);
Vue.use(Input);
Vue.use(Col);
Vue.use(Dialog);
Vue.use(RadioGroup);
Vue.use(RadioButton);
Vue.use(Form);
Vue.use(FormItem);
Vue.use(Row);
Vue.use(Radio);
Vue.use(Popconfirm);
Vue.use(Upload);
Vue.use(Breadcrumb);
Vue.use(BreadcrumbItem);
Vue.use(DatePicker);
Vue.use(Checkbox);
Vue.use(Menu);
Vue.use(Submenu);
Vue.use(MenuItem);
Vue.use(MenuItemGroup);
Vue.use(Empty);
Vue.prototype.$message = Message;

// 全局方法
/**
 * 获取图片路径
 */
Vue.prototype.$getImageSrc = (name) => {
  let imgSrc;
  try {
    imgSrc = require(`./assets/images/${name}`);
  } catch (error) { }

  return imgSrc;
};
/**
 * 获取svg图标路径
 */
Vue.prototype.$getIconSrc = (name) => {
  return require(`./assets/svg/icon-${name}.svg`);
};
/**
 * 设置基础请求路径
 */
Vue.prototype.$baseAPI = process.env.VUE_APP_BASE_API;
Vue.prototype.$testUsername = process.env.VUE_APP_TEST_USERNAME;
Vue.prototype.$testPassword = process.env.VUE_APP_TEST_PASSWORD;

export default new Vue({
  router,
  store,
  render: (h) => h(Index),
}).$mount('#app');
